import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import uuidv4 from "uuid/v4";

const TableHeader = ({ column, name, headerClass, sort, desc, setRemoteDesc, setRemoteSort }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  let tooltipText = `Ordenar por ${name.toLowerCase()}`;
  if (column.isSorted) {
    tooltipText += !column.isSortedDesc ? " descendentemente" : " ascendentemente";
  }
  const sortByToggleProps = column.getSortByToggleProps();
  const { isSorted, isSortedDesc, id } = column;
  sortByToggleProps.title = undefined;
  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  const header = column.render("Header").trim();
  let customHeaderClass = headerClass;
  if (column.type && column.type === "number") {
    customHeaderClass += "number-header";
  }
  if (isSorted) {
    if (id !== sort) {
      setRemoteSort(id);
    }
    if (Boolean(isSortedDesc) !== desc) {
      setRemoteDesc(isSortedDesc || false);
    }
  } else if (id === sort) {
    setRemoteSort("");
  }
  return (
    <th id={uuid} {...column.getHeaderProps(sortByToggleProps)} className={customHeaderClass}>
      {header}
      {isSorted ? <i className={`icono-sort ${!isSortedDesc ? "asc" : "desc"}`} /> : null}
      {header && (
        <Tooltip placement="top" isOpen={isOpen} target={uuid} toggle={toggle}>
          {tooltipText}
        </Tooltip>
      )}
    </th>
  );
};

TableHeader.propTypes = {
  column: PropTypes.shape().isRequired, // objeto column de react-table
  name: PropTypes.string.isRequired,
  headerClass: PropTypes.string,
  sort: PropTypes.string,
  desc: PropTypes.bool,
  setRemoteDesc: PropTypes.func,
  setRemoteSort: PropTypes.func
};

TableHeader.defaultProps = {
  headerClass: "",
  sort: "",
  desc: false,
  setRemoteDesc: () => {},
  setRemoteSort: () => {}
};

export default TableHeader;
